import React from 'react';

export default function Logo({ size = 'md', showText = false, className = '' }) {
  const sizes = {
    sm: 'h-8 w-8',
    md: 'h-10 w-10',
    lg: 'h-14 w-14',
    xl: 'h-24 w-24',
    hero: 'h-40 w-40 md:h-56 md:w-56'
  };

  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="app-logo">
      <img
        src="/logo.png"
        alt="Errands Boy"
        className={`${sizes[size]} object-contain`}
      />
      {showText && (
        <div className="hidden sm:flex flex-col leading-tight">
          <span className="font-bold text-slate-900 text-lg tracking-tight">ERRANDS <span className="text-yellow-500">BOY</span></span>
        </div>
      )}
    </div>
  );
}
